const HOT_ZONE_PX = 72; // distance from an edge where auto-scroll engages
const MIN_SPEED_PX = 2; // px per frame at the inner boundary of the zone
const MAX_SPEED_PX = 18; // px per frame at the very edge

function clamp01(value) {
  if (value < 0) {
    return 0;
  }
  if (value > 1) {
    return 1;
  }
  return value;
}

export default {
  created() {
    this._dragScrollContainer = null;
    this._dragScrollFrame = null;
    this._dragScrollPointerX = 0;
    this._dragScrollPointerY = 0;
    this._dragScrollActive = false;
    this._dragScrollMoveHandler = (event) => {
      this._dragScrollPointerX = event.clientX;
      this._dragScrollPointerY = event.clientY;
    };
  },
  beforeDestroy() {
    this.endDragAutoScroll();
  },
  methods: {
    beginDragAutoScroll(container) {
      if (!container) {
        return;
      }
      this._dragScrollContainer = container;
      this._dragScrollActive = true;
      document.addEventListener('dragover', this._dragScrollMoveHandler, true);
      if (this._dragScrollFrame == null) {
        this._dragScrollFrame = window.requestAnimationFrame(
          this._dragAutoScrollStep
        );
      }
    },
    endDragAutoScroll() {
      this._dragScrollActive = false;
      this._dragScrollContainer = null;
      document.removeEventListener(
        'dragover',
        this._dragScrollMoveHandler,
        true
      );
      if (this._dragScrollFrame != null) {
        window.cancelAnimationFrame(this._dragScrollFrame);
        this._dragScrollFrame = null;
      }
    },
    _dragAutoScrollStep() {
      this._dragScrollFrame = null;
      const container = this._dragScrollContainer;
      if (!this._dragScrollActive || !container) {
        return;
      }

      const rect = container.getBoundingClientRect();
      const x = this._dragScrollPointerX;
      const y = this._dragScrollPointerY;
      const withinX = x >= rect.left && x <= rect.right;
      const topDistance = y - rect.top;
      const bottomDistance = rect.bottom - y;

      let delta = 0;
      if (withinX && topDistance < HOT_ZONE_PX) {
        const intensity = clamp01((HOT_ZONE_PX - topDistance) / HOT_ZONE_PX);
        delta = -(MIN_SPEED_PX + (MAX_SPEED_PX - MIN_SPEED_PX) * intensity);
      } else if (withinX && bottomDistance < HOT_ZONE_PX) {
        const intensity = clamp01((HOT_ZONE_PX - bottomDistance) / HOT_ZONE_PX);
        delta = MIN_SPEED_PX + (MAX_SPEED_PX - MIN_SPEED_PX) * intensity;
      }

      if (delta !== 0) {
        container.scrollTop += delta;
      }

      // Keep the loop alive for the whole drag so scrolling continues even when
      // the pointer is held still (dragover throttles/stops when stationary).
      this._dragScrollFrame = window.requestAnimationFrame(
        this._dragAutoScrollStep
      );
    },
  },
};
